export abstract class AppHelper {
  public static get generateContinueUrl() {
    return `${window.location.origin}`;
  }

  public static get progressImgUrl() {
    return `${window.location.origin}/assets/images/iframe-loader.gif`;
  }
}
